var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [{ name: "drag", rawName: "v-drag" }],
      attrs: {
        visible: _vm.dialogVisible,
        width: "1000px",
        title: _vm.editData.id ? "修改清关咨询信息" : "新增清关咨询信息",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
        "append-to-body": "",
        top: "5vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "form",
          attrs: { model: _vm.form, rules: _vm.rules, "label-position": "top" },
        },
        [
          _c(
            "el-row",
            { staticClass: "row", attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "中文品名", prop: "nameCH" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.nameCH,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "nameCH", $$v)
                          },
                          expression: "form.nameCH",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "英文品名", prop: "nameEN" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.nameEN,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "nameEN", $$v)
                          },
                          expression: "form.nameEN",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "用途", prop: "usedFor" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.usedFor,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "usedFor", $$v)
                          },
                          expression: "form.usedFor",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "材质", prop: "material" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.material,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "material", $$v)
                          },
                          expression: "form.material",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "row", attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "原产国", prop: "originCountry" } },
                    [
                      _c(
                        "el-select",
                        {
                          model: {
                            value: _vm.form.originCountry,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "originCountry", $$v)
                            },
                            expression: "form.originCountry",
                          },
                        },
                        _vm._l(_vm.addressDropOption, function (item) {
                          return _c("el-option", {
                            key: item.code,
                            attrs: { label: item.label, value: item.code },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否可清关", prop: "isClearence" } },
                    [
                      _c("el-switch", {
                        attrs: {
                          "active-color": "#13ce66",
                          "inactive-color": "#ff4949",
                        },
                        model: {
                          value: _vm.form.isClearence,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "isClearence", $$v)
                          },
                          expression: "form.isClearence",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "客户", prop: "companyId" } },
                    [
                      _c(
                        "el-select",
                        {
                          model: {
                            value: _vm.form.companyId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "companyId", $$v)
                            },
                            expression: "form.companyId",
                          },
                        },
                        _vm._l(_vm.companyDrapdown, function (item, $index) {
                          return _c("el-option", {
                            key: $index,
                            attrs: { label: item.label, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "美国税号", prop: "hsCode" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.hsCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "hsCode", $$v)
                          },
                          expression: "form.hsCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "row", attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "基础税率", prop: "baseRate" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.baseRate,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "baseRate", $$v)
                          },
                          expression: "form.baseRate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "加征税率1", prop: "addRate1" } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "controls-position": "right",
                          min: 0,
                          precision: 2,
                          step: 1,
                        },
                        model: {
                          value: _vm.form.addRate1,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "addRate1", $$v)
                          },
                          expression: "form.addRate1",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "加征税率2", prop: "addRate2" } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "controls-position": "right",
                          min: 0,
                          precision: 2,
                          step: 1,
                        },
                        model: {
                          value: _vm.form.addRate2,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "addRate2", $$v)
                          },
                          expression: "form.addRate2",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "加征税率3", prop: "addRate3" } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "controls-position": "right",
                          min: 0,
                          precision: 2,
                          step: 1,
                        },
                        model: {
                          value: _vm.form.addRate3,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "addRate3", $$v)
                          },
                          expression: "form.addRate3",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "row", attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "清关条件", prop: "conditions" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.conditions,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "conditions", $$v)
                          },
                          expression: "form.conditions",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注", prop: "remark" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "remark", $$v)
                          },
                          expression: "form.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "row", attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("el-form-item", { attrs: { prop: "systemFileId" } }, [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v(" 上传文件"),
                      _c("span", { staticStyle: { color: "#FE453D" } }, [
                        _vm._v("(仅支持图片文件)"),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "upload" },
                      [
                        _c(
                          "el-upload",
                          {
                            staticClass: "upload-demo",
                            attrs: {
                              action: "/api/SystemFile/uploadFile?source=17",
                              data: { source: 17 },
                              headers: _vm.headers,
                              "before-upload": _vm.beforeUpload,
                              "on-success": _vm.onSuccess,
                              "before-remove": _vm.handleRemove,
                              "file-list": _vm.fileList,
                              "list-type": "picture",
                            },
                          },
                          [
                            _c(
                              "el-button",
                              { attrs: { size: "small", type: "primary" } },
                              [_vm._v("点击上传")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        { staticClass: "footers", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "div",
            { staticClass: "cancel flex_c_c", on: { click: _vm.cancel } },
            [_vm._v("取消")]
          ),
          _c(
            "div",
            {
              staticClass: "ok flex_c_c",
              on: {
                click: function ($event) {
                  return _vm.ok("form")
                },
              },
            },
            [_vm._v(" 确定" + _vm._s(_vm.editData.id ? "修改" : "新增") + " ")]
          ),
        ]
      ),
      _c("TaxDialog", {
        attrs: { dialogVisible: _vm.dialogVisible2 },
        on: { ok: _vm.ok2, cancel: _vm.cancel2 },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }